const TABS = [
  { key: 0, label: "Inscritos" },
  { key: 2, label: "Rechazados" },
  { key: 1, label: "Pendientes" },
];

export default TABS;
